module.exports = __webpack_public_path__ + "img/52.d6c04bb.png";